import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle, Modal, Form, Container, Button, Alert, UncontrolledTooltip, Table, UncontrolledDropdown, DropdownToggle, DropdownMenu } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate, downloadBase64File } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader'

    const LeaveRequestDetails = () => {

        const history = useHistory();
        const {no} = useParams();

        const [lR, setLR] = useState({})
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [gender, setGender] = useState('');
        const [hrManagerNo, setHRManagerNo] = useState('');
        const [leaveNo, setLeaveNo] = useState('');
        const [supervisorNo, setSupervisorNo] = useState('');
        const [supervisorName, setSupervisorName] = useState('');
        const [leaveCategory, setLeaveCategory] = useState('');
        const [startDate, setStartDate] = useState(new Date());
        const [endDate, setEndDate] = useState(new Date());
        const [leaveStatus, setLeaveStatus] = useState('');
        const [st, setSt] = useState('danger');
        const [hrManagerName, setHRManagerName] = useState('');
        const [departmentCode, setDepartmentCode] = useState('');
        const [postingDate, setPostingDate] = useState('');
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [selectedDates, setSelectedDates] = useState([new Date(), new Date()])
        const [leaveRequestLines, setLeaveRequestLines] = useState([])
        const [selectedFile, setSelectedFile] = useState([])
        const [loadingFiles, setLoadingFiles] = useState(false)

        const [CompanyID, setCompanyID] = useState("")
        const [showApproveBtn, setShowApproveBtn] = useState(true);
        const [showRejectBtn, setShowRejectBtn] = useState(false);
        const [comment, setComment] = useState('')

        const [modal_line, setmodal_line] = useState(false)

        const [cCode, setCCode] = useState('')
        const [causesofabsence, setCausesofAbsence] = useState([])
        const [documentID, setDocumentID] = useState('')
        const [isEdit, setIsEdit] = useState(false)
        const [quantity, setQuantity] = useState(0)
        const [description, setDescription] = useState('')
        const [lineSystemID, setLineSystemId] = useState('')
        const [selectedType, setSelectedType] = useState('')

        toastr.options = TOAST_OPTIONS;
        const [inputs, setInputs] = useState([]);
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }
        const handleSubmit = (event) => {
            event.preventDefault();
            toastr.success("Leave Request No  created" ); 
        }
        
        const handleActionChange = () =>{
            const selectedAction = document.getElementsByClassName('lAction')[0].value;
                if(selectedAction == 'APPROVE'){
                    setShowApproveBtn(true)
                    setShowRejectBtn(false)
                }else if(selectedAction == 'REJECT'){
                    setShowApproveBtn(false)
                    setShowRejectBtn(true)
                }
        }
        const handleRejectLR = () =>{
            setIsloading(true)
            const lNo = {"no":leaveNo, "newcomment":comment}
            axios.post(url.REJECT_LR+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    if(response.status == '200'){
                        toastr.info("Leave approval rejected");
                        history.push(`/leave-approvals`) 
                    }else{
                        toastr.error("Could not reject leave request" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    console.log(error)
                    setIsloading(false)
            })  
        }

        const handleApproveLR = () =>{
            setIsloading(true)
            const lNo = {'no': leaveNo}
            axios.post(url.APPROVE_LR +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success("Leave request Approved" );
                        history.push(`/leave-approvals`) 
                    }else{
                        toastr.error("Could not Approve leave request" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
                })
        }

   
        const fetchData = () =>{
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            let EmployeeNo = obj.uid;
            setCompanyID(obj.activeCompany);
            setIsloading(true) 
            axios.get(`${url.LEAVE_REQUESTS}?$filter=no eq '${no}'&$expand=leaveRequestLines&company='${obj.activeCompany}'`, HRConfig)
                .then(function(response){
                    setLR(response.data);
                    setEmpNo(response.data.value[0].employeeNo);
                    setEmpName(response.data.value[0].employeeName);
                    setLeaveNo(response.data.value[0].no);
                    setLoadingFiles(true)
                    // axios.get(`${url.ATTACHDOCUMENTS}?$filter=No eq '${response.data.No}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{
                    //     setSelectedFile(r.data.value)
                    //     setLoadingFiles(false)
                    // }).catch((e)=>{ console.log(e); setLoadingFiles(false) })

                    axios.get(`${url.EMPLOYEES2}?$filter=No eq '${response.data.value[0].employeeNo}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{
                        setEmpTitle(r.data.value[0].JobTitle);
                        setGender(r.data.value[0].Gender);
                        setIsloading
                    }).catch((e)=>{ console.log(e); setIsloading(false) })

                    axios.get(url.CAUSES_OF_ABSENCE +"?company="+ obj.activeCompany, HRConfig).then((r)=>{ 
                        setCausesofAbsence(r.data.value);
                    }).catch((e)=>{
                        console.log(e) 
                    })

                    setSupervisorNo(response.data.value[0].supervisorNo);
                    setLeaveStatus(response.data.value[0].status);
                    setStartDate(response.data.value[0].From_Date);
                    setEndDate(response.data.value[0].To_Date);
                    setSupervisorName(response.data.value[0].supervisorName);
                    setHRManagerNo(response.data.value[0].hRManagerNo);
                    setHRManagerName(response.data.value[0].hRManagerName);
                    setDepartmentCode(response.data.value[0].departmentCode);
                    setSelectedDates([ new Date(response.data.From_Date), new Date(response.data.To_Date)])
                    setPostingDate(response.data.value[0].postingDate);
                    setLeaveRequestLines(response.data.value[0].leaveRequestLines)
                    if(leaveStatus == 'Pending'){
                        setSt('warning');
                    }else if(leaveStatus == 'Approved'){
                        setSt('success');
                    }else{
                        setSt('danger');
                    }
                    setIsloading(false)
                    setUserError(false);
                }).catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setUserError(true);
                    setIsloading(false)
                })
        }
        useEffect(() => {
            fetchData()
        },[]);
       
        const handleDownload = (clickedFile) => {
            const base64String = clickedFile.FileContentsBase64;
            const fileName = clickedFile.FileName;
            const fileExtension = clickedFile.FileExtension;
            const contentType = clickedFile.fileContentType;
            downloadBase64File(base64String, fileName, fileExtension, contentType);
        }
        
        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Leave Request Details | {url.APPNAME}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={url.APPNAME} breadcrumbItem={`Leave Request Details`} />
                        <Form onSubmit={handleSubmit}>
                    
                            <Alert color={`${st}`} role="alert">
                                    <strong>{leaveStatus}</strong>
                            </Alert>
           
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                                <CardTitle>Employee Details</CardTitle>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th scope="col"> Number</th>
                                                    <td scope="col"> {empNo} </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col"> Name</th>
                                                    <td scope="col">{empName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Position</th>
                                                    <td scope="col">{empTitle}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Gender</th>
                                                    <td>{gender}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>

                            <div className="d-flex">
                                <div className="flex-grow-1 ms-1">                                 
                                    <ul className="list-unstyled vstack gap-2 mb-0">
                                        <div className="d-grid gap-2">
                                            <Col md={12}>
                                                <div className="mb-3">
                                                <label htmlFor="floatingSelectGrid"> Select Action</label>
                                                    <select  className="form-select lAction" onChange={handleActionChange}>
                                                        
                                                        <option value="APPROVE">APPROVE LEAVE REQUEST</option>
                                                        <option value="REJECT">REJECT LEAVE REQUEST</option>
                                
                                                    </select>
                                                    
                                                </div>
                                            </Col>
                                            {showRejectBtn && (
                                                <div className="form-floating mb-3">
                                                    <input  type="text" className="form-control" onChange={(e)=>setComment(e.target.value)}  />
                                                    <label htmlFor="floatingSelectGrid"> Rejection Comment</label>
                                                </div>
                                            )}
                                            {showRejectBtn && (
                                            <Col md={12} className="reject">
                                                <div className="d-grid gap-2">
                                                    <Button color="danger" type="button" className="btn btnRejectRequest" onClick={handleRejectLR}>
                                                        <i className="mdi mdi-cancel"/>{" "}
                                                            Reject Leave Request
                                                    </Button>
                                                </div>
                                            </Col>
                                            )}
                                            {showApproveBtn && (
                                            <Col md={12} className="approve">
                                                <div className="d-grid gap-2">
                                                    <Button color="primary" type="button" className="btn btnApproveRequest" onClick={handleApproveLR}>
                                                        <i className="mdi mdi-check-circle-outline text-success"/>{" "}
                                                            Approve Leave Request
                                                    </Button>
                                                </div>
                                            </Col>
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </div>
                            </Col>
                            <Col  xl={8}>
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-3">
                                        Leave Request Details
                                    </CardTitle>
                                    <div className="table-responsive">
                                        <Row>
                                            <Col md={5}>
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="col"> Request Number</th>
                                                            <td scope="col"> {leaveNo} </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col"> Posting Date</th>
                                                            <td scope="col">{postingDate}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Department Code</th>
                                                            <td scope="col">{departmentCode}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Status</th>
                                                            <td>{leaveStatus}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Col>
                                            <Col md={7}>
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="col"> Supervisor No</th>
                                                            <td scope="col"> {supervisorNo} </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col"> Supervisor Name</th>
                                                            <td scope="col">{supervisorName}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">HR Manager No</th>
                                                            <td scope="col">{hrManagerNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">HR Manager Name</th>
                                                            <td scope="col">{hrManagerName}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Col>
                                        </Row>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <CardTitle className= "mb-3 mt-1 justify-content-center">
                                        Leave Request Lines ({leaveRequestLines.length})
                                    </CardTitle>
                                    <CardBody className="border-bottom">
                                        {(leaveStatus == 'Pending') ? (
                                            <div className="table-responsive">
                                                <Table  className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Leave Type</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Start Date</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>End Date</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Quantity</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Description</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {leaveRequestLines.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Leave_Type}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Start_Date}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Return_Date}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Quantity}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Description}</td> 
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> 
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        ):(
                                            <div className="text-center">
                                                <div className="mb-4">
                                                    <i className="mdi mdi-calendar-edit text-warning display-4" />
                                                </div>
                                                <div>
                                                    <h5>No Leave Request Lines added, yet!</h5>
                                                </div>
                                            </div>
                                        )}
                                    </CardBody>

                                    <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                        <div className="modal-header">
                                            <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update/Delete `:`Add ` }Leave Request Line</h5>
                                            <button type="button"  onClick={() => { setmodal_line(false) }}  className="close" data-dismiss="modal"aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <label htmlFor="floatingIdInput">Leave Type</label>
                                                        <select className="form-select" value={cCode} onChange={(e)=>setCCode(e.target.value)}>
                                                            <option value=""></option>
                                                            {causesofabsence.map((c,k)=>(
                                                                <option key={k} value={c.Code}>{c.Description}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <label htmlFor="floatingDepartInput">Start Date - End Date</label>
                                                        <Flatpickr
                                                            className="form-control"
                                                            placeholder="dd M,yyyy"
                                                            options={{
                                                                mode: "range",
                                                                dateFormat: "Y-m-d"
                                                            }}
                                                            value={selectedDates}
                                                            onChange={(dates) =>{setSelectedDates(dates)} }
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    
                                </Modal>
                            </CardBody> 
                        </Card>

                                    

                            {/* <Card>
                                <CardBody>
                                    <CardTitle>Attachments</CardTitle>
                                    {loadingFiles ? (
                                        <>
                                        <div className="text-center">
                                                    <div className="mb-4">
                                                    </div>
                                                    <div>
                                                    <h5>Loading attached files please wait ...</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                        </>
                                    ): ((selectedFile.length > 0)?(
                                        <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>File</th>
                                                            
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {selectedFile.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{k+1}</td>
                                                                <td>
                                                                
                                                                <Link to="#" onClick={()=>handleDownload(selectedFile[k])}>{a.FileName}</Link></td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                
                                                                    <div className="d-flex gap-3">
                                                                    {(leaveStatus == 'Open') && (
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => removeFile(selectedFile[k])}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                        )}
                                                                    </div>
                                                               
                                                                    </></td>
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No file attached</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            ))}
                            
                                </CardBody>
                            </Card> */}
                                                                        
                    
                        </Col>
                        </Row>
                        </Form>


                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default LeaveRequestDetails;